export const quickstock = {
  quickstock: {
    legend: {
      stock: 'Stock Disponível',
      lowstock: 'Stock Limitado',
      nostock: 'Sem Stock'
    },
    errors: {
      subcategories: "Erro no servidor, não foi possível carregar as subcategorias.",
      categories: "Erro no servidor, não foi possível carregar as categorias.",
      nostock: "Produto sem stock.",
    },
    notification: {
      title: 'Notificar-me',
      alert: 'Seja o primeiro a saber',
      alertunsubscribe: 'Se você cancelar a inscrição, não receberá uma notificação quando o produto estiver disponível novamente em stock. Deseja continuar?',
      explanation: 'Você será notificado assim que o artigo estiver novamente em stock.',
      selectnotifications: 'Selecione como gostaria de receber as notificações.',
      email: 'E-mail',
      cancel: 'Cancelar',
      subscribe: 'Assinar',
      unsubscribe: 'Cancelar assinatura',
      updated: 'Solicitação feita com sucesso!'
    }
  }
};
